module.exports = __webpack_public_path__ + "static/media/wwd_level_design.d45bdcd0.svg";